import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import IngredientList from './IngredientList';
import RecipeList from './RecipeList';




const AdminPanel = () => {

    return (
    <Row>
        <Col className='text-center'>
            <h1>Opskrifter</h1>
            <RecipeList />


        </Col>
        <Col>
            <h1>Ingredienser</h1>
            <IngredientList />

            
        </Col>
    </Row>
    );

}

export default AdminPanel;